export const bookmakersNames = {
  4: 'William Hill NJ',
  15:'Bet 365',
  8667:'Bet 365',
  6415: '888sport(d)',
  7944: 'DraftKings',
  8014: 'SugarHouse',
  8030: 'FanDuel',
  8089: 'Betstars NJ',
  8081: 'Caesars',
  8644: 'Caesars',
  8686: 'Caesars',
  50046: 'Caesars Nj',
  8829: 'Bet MGM',
  8817: 'DoradoBet',
  6146: 'Betsson',
  8764: 'BetPlay',
  8881: 'Betcris',
  6718: 'CoolBet',
  50076: 'Bet 365',
  50079: '888sport',
  50255: 'Betregal',
  110001: 'DraftKings'
} as { [bookmakerId in string]: string }
